import { render, staticRenderFns } from "./EditCustomerTypeForm.vue?vue&type=template&id=f75449e0&"
import script from "./EditCustomerTypeForm.vue?vue&type=script&lang=js&"
export * from "./EditCustomerTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports